import { render, staticRenderFns } from "./ViewMessagesModal.vue?vue&type=template&id=316bbefe&"
import script from "./ViewMessagesModal.vue?vue&type=script&lang=js&"
export * from "./ViewMessagesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports